import getService from "../getService";

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/";

const COURSEBYRATING = "reports/top-courses/rating";
const COURSEBYREVENUE = "reports/top-courses/revenue ";
const COURSEBYENROLMENT = "reports/top-courses/enrolment ";

export default class ReportsService {
  static async getCourseByRating() {
    const response = await getService.get(CONFIG_API_URL + COURSEBYRATING);
    const data: any = response.data;
    return data;
  }

  static async getCourseByRevenue() {
    const response = await getService.get(CONFIG_API_URL + COURSEBYREVENUE);
    const data: any = response.data;
    return data;
  }

  static async getCourseByEnrolment() {
    const response = await getService.get(CONFIG_API_URL + COURSEBYENROLMENT);
    const data: any = response.data;
    return data;
  }

  static async getTraffic() {
    const response = await getService.get(`${CONFIG_API_URL}visits`);
    const data: any = response.data;
    return data;
  }
}
